type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

/**
 * Every container loads its own snippet against the shared `dataLayer`, so
 * each one receives every `trackEvent` push.
 */
export const GTM_CONTAINER_IDS = ["GTM-M4LFKQZ", "GTM-P27NBFGS"];

export const trackEvent = (name: string, params: any) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: name,
      ...params,
    });
  }
};
